import type { FC } from 'react';

import { MoreVertical } from 'lucide-react';

import { useUserRowActions } from '@features/user-management/hooks/useUserRowActions';
import { Button } from '@shared/components/ui';
import { GenericDropdown } from '@shared/components/ui/custom';

import type { User } from '../api/user-management.types';

export const UserRowActions: FC<{ rowData: User }> = ({ rowData }) => {
  const { canDeleteOrLock, handleDeleteUserClick } = useUserRowActions(rowData);

  return (
    <div className="flex items-center gap-2">
      <GenericDropdown
        trigger={
          <Button
            variant="ghost"
            size="sm"
            className="h-8 w-8 p-0"
            onClick={(e) => e.stopPropagation()}
            data-testid={`user-management-actions-trigger-${rowData.email}`}
          >
            <MoreVertical className="w-4 h-4" data-testid={`user-management-actions-icon-${rowData.email}`} />
          </Button>
        }
        options={[
          {
            label: 'Delete User',
            value: 'delete',
            className: 'text-destructive-foreground',
            disabled: !canDeleteOrLock,
            'data-testid': 'delete-user-action',
          },
        ]}
        onClick={(value) => {
          if (value === 'delete') handleDeleteUserClick();
        }}
        data-testid="user-management-row-actions-btn"
      />
    </div>
  );
};
